import Api from './Api';

const endpoint = '/fibu/buchungsvorlage';

export default {
    abort() {
        Api.abort(abortKey);
    },
    getBuchungsvorlage(id, bsid) {
        return Api.fetchData(endpoint + '/' + id + '/buchungsstapel/' + bsid);
    },
    post(data, id) {
        return Api.postData(endpoint + '/new/buchungsstapel/' + id, data);
    },
    put(data, id) {
        return Api.putData(endpoint + '/' + id, data);
    },
    putSeleted(data) {
      return Api.putData(endpoint + '/buchungsvorlagen/anpassen', data);
    },
    delete(id) {
        return Api.deleteData(endpoint + '/' + id);
    }
};